import { Badge, Button, Card, EmptyState, Spinner, useToast } from "@closer/ui";
import { useState } from "react";
import { useNavigate } from "react-router";

import { type Membership, useAuth } from "../../lib/authContext";
import { CreateTenantModal } from "./CreateTenantModal";

const roleLabels: Record<Membership["role"], string> = {
  owner: "Sahip",
  admin: "Yönetici",
  member: "Üye",
};

export function TenantsPage() {
  const {
    memberships,
    isLoading,
    membershipsLoading,
    membershipsError,
    setActiveTenant,
    user,
    logout,
  } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();
  const [createOpen, setCreateOpen] = useState(false);

  function selectTenant(tenantId: string) {
    setActiveTenant(tenantId);
    navigate("/app");
  }

  async function handleLogout() {
    await logout();
    toast.info("Oturum kapatıldı");
    navigate("/login");
  }

  return (
    <div className="mx-auto flex min-h-screen w-full max-w-lg flex-col justify-center gap-4 p-4">
      <Card
        title="Firma Seç"
        actions={
          <Button size="sm" onClick={() => setCreateOpen(true)}>
            Yeni Firma
          </Button>
        }
      >
        {/* Oturum VEYA üyelik listesi yüklenirken bekle: erken bakılsaydı firması OLAN
            kullanıcıya bir an "firmanız yok" boş durumu çakardı (denetim bulgusu). */}
        {isLoading || membershipsLoading ? (
          <div className="flex justify-center py-8">
            <Spinner />
          </div>
        ) : membershipsError ? (
          // Ağ/sunucu hatası "firmanız yok" olarak MASKELENMEZ: farklı sorun, farklı çare.
          <EmptyState
            title="Firmalarınız yüklenemedi"
            description="Bağlantı sorunu olabilir."
            action={<Button onClick={() => window.location.reload()}>Yeniden dene</Button>}
          />
        ) : memberships.length === 0 ? (
          <EmptyState
            title="Henüz bir firmanız yok"
            description="Başlamak için yeni bir firma oluşturun."
            action={<Button onClick={() => setCreateOpen(true)}>Yeni Firma</Button>}
          />
        ) : (
          <ul className="flex flex-col gap-2">
            {memberships.map((membership) => (
              <li key={membership.tenantId}>
                <button
                  type="button"
                  onClick={() => selectTenant(membership.tenantId)}
                  className="flex w-full items-center justify-between rounded-md border border-slate-200 px-4 py-3 text-left transition-colors hover:border-primary hover:bg-primary/5"
                >
                  <span className="text-sm font-medium text-slate-900">{membership.name}</span>
                  <Badge>{roleLabels[membership.role]}</Badge>
                </button>
              </li>
            ))}
          </ul>
        )}
      </Card>
      <p className="text-center text-sm text-slate-500">
        {user?.email} —{" "}
        <button
          type="button"
          onClick={() => void handleLogout()}
          className="font-medium text-primary hover:underline"
        >
          Çıkış
        </button>
      </p>
      <CreateTenantModal open={createOpen} onClose={() => setCreateOpen(false)} />
    </div>
  );
}
